import React from 'react';
import Renderer from '../renderer';

export default function Answer({ onChange, index = 0, choice, type, className, selectedAnswer }) {
  const { label, value, id } = choice || {};
  const highlighted = selectedAnswer && Boolean(selectedAnswer[id]);

  const getInputType = () => {
    switch (type) {
      case 'MCQ':
      case 'MSQ':
        return 'checkbox';

      default:
        return 'radio';
    }
  }

  return (
    <div key={index ?? 0} className={(highlighted ? 'option-highlighted' : '') + '  answer-option ' + className} style={styles.base}>
      <label className='answer-label' style={{ position: 'relative', minHeight: '40px' }}>
        <span className='option-label' style={styles.text}>{index + 1}.</span>
        <input style={styles.input}
          id={id}
          data={JSON.stringify(choice)}
          // radio is for checked one option and checkbox is for checked multiple options
          type={getInputType()}
          checked={highlighted}
          onChange={onChange}
        />
        <Renderer
          content={value?.text}
          contentType={choice.value?.style}
          contentUrl={choice.value?.contentURL}
          enableTextToAudio={choice.value?.enableTextToAudio}
          templateType={choice.value?.displayTemplate}
          overrideHTML={choice.value?.overrideHTML}
          mediaStyle={{ height: choice.value?.contentURL ? '100px' : '150px', width: choice.value?.contentURL ? '100px' : '150px' }}
          style={{
            padding: '4px 4px 4px 46px',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}
        />
      </label>
    </div>
  )
}

const styles = {
  base: {
    fontSize: "clamp(18px, 4vw, 16px)",
    color: "var(--mui-palette-text-primary)",
    fontWeight: 400,
    backgroundColor: "white",
    cursor: "pointer",
    padding: "0",
    minHeight: "42px",
    backgroundColor: "#F3F8FB",
    border: "1px solid #CDE6F5",
    borderRadius: "2px",
  },
  text: {
    position: "absolute",
    left: "0",
    top: "0",
    backgroundColor: "var(--mui-palette-common-white)",
    color: "var(--mui-palette-common-black)",
    width: "40px",
    height: "98%",
    textAlign: "center",
    border: "1px solid #CDE6F5",
    borderRadius: "4px",
    fontSize: "20px",
    zIndex: "2",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  highlightd: {
    backgroundColor: "skyblue",
    border: `2px solid blue`,
  },
  input: {
    visibility: "hidden",
    margin: 0,
    position: "absolute",
    width: "100%",
    height: "100%",
  },
};
